import { Image, Pressable } from 'native-base';
import React from 'react';

import { Locale } from 'app/generated/hygraph';
import { useI18n } from 'app/providers/I18nProvider';
import { tID } from 'app/services/TestHelper';

/* eslint-disable @typescript-eslint/no-var-requires */
const en = require('app/assets/images/wallet/apple/add-to-wallet-en.png');
const de = require('app/assets/images/wallet/apple/add-to-wallet-de.png');
const es = require('app/assets/images/wallet/apple/add-to-wallet-es.png');
const fr = require('app/assets/images/wallet/apple/add-to-wallet-fr.png');
const it = require('app/assets/images/wallet/apple/add-to-wallet-it.png');
const ja = require('app/assets/images/wallet/apple/add-to-wallet-ja.png');
const pt = require('app/assets/images/wallet/apple/add-to-wallet-pt.png');
const zh = require('app/assets/images/wallet/apple/add-to-wallet-zh.png');
/* eslint-enable @typescript-eslint/no-var-requires */

const btnImage: Record<Locale, any> = {
  [Locale.En]: en,
  [Locale.De]: de,
  [Locale.Es]: es,
  [Locale.Fr]: fr,
  [Locale.It]: it,
  [Locale.Ja]: ja,
  [Locale.Pt]: pt,
  [Locale.Zh]: zh,
};

export type AddToAppleWalletButtonProps = {
  onPress?: () => void;
};

export default function AddToAppleWalletButton({ onPress }: AddToAppleWalletButtonProps) {
  const { t, locale } = useI18n();

  return (
    <Pressable testID={tID('AddToAppleWalletButton')} onPress={onPress}>
      <Image
        alignSelf="stretch"
        alt={t<string>('app_add_to_apple_wallet')}
        flex="1"
        resizeMode="contain"
        source={btnImage[locale] ?? btnImage.en}
      />
    </Pressable>
  );
}
